export enum ConfirmDialogKeys {
  appVersionUpdate = 'app-version-update',
  smartBan = 'smartBan',
  flightViewLineitemsGrid = 'flight-view-lineitems-grid',
  flightViewLineitemsGridCopyAsk = 'flight-view-lineitems-grid-copy-ask',
  flightViewLineitemsGridCopyMessage = 'flight-view-lineitems-grid-copy-message',
  flightPageForm = 'flight-page-form',
  advertiserEditPageLess = 'advertiser-edit-page-less',
  advertiserEditPageMore = 'advertiser-edit-page-more',
  channelBehaviouralFormPage = 'channel-behavioural-form-page',
  channelBehaviouralFormPageEdit = 'channel-behavioural-form-edit',
  channelBehaviouralFormPageDelete = 'channel-behavioural-form-delete',
  compositeSegmentsFormPage = 'composite-segments-form-page',
}
